export { default } from './component';


// WEBPACK FOOTER //
// ./components/Agile/initiative/index.js